import { useFeiertagskonto } from '@/domain/mitarbeiter/features/feiertagskonto/hooks';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Card,
  CardContent,
  EmptyState,
  Heading,
  Title,
} from '@e2n/ui/v2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { faCalendarCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import dayjs from 'dayjs';
import { BemerkungDrawer } from '@/domain/mitarbeiter/features/feiertagskonto/components/kontoausgleich/BemerkungDrawer';
import { KontausgleichArtBadge } from '@/domain/mitarbeiter/features/feiertagskonto/components';
import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';

export function KontoausgleichMobile() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { zeitraum } = useYearPickerContext();
  const { kontoausgleiche } = useFeiertagskonto({
    mitarbeiterId: id,
    zeitraum: zeitraum,
  });
  return (
    <div className="flex flex-col gap-4">
      <Heading size="md" weight="bold">
        {t('domain.mitarbeiter.feiertagskonto.kontoausgleich.titel')}
      </Heading>
      {kontoausgleiche.length > 1 ? (
        <Card>
          <CardContent>
            {kontoausgleiche.map((item, i) => (
              <Accordion key={i} className="w-119" type="multiple">
                <AccordionItem
                  value={t(
                    'domain.mitarbeiter.feiertagskonto.kontoausgleich.datum',
                  )}>
                  <AccordionTrigger>
                    {dayjs(item.datum).format('dd., DD.MM')}
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="flex flex-col gap-4">
                      <div className="flex gap-4">
                        <div className="flex flex-col p-0.5">
                          <Title className="text-labels-secondary text-xs font-semibold">
                            {t(
                              'domain.mitarbeiter.feiertagskonto.kontoausgleich.art',
                            )}
                          </Title>
                          <KontausgleichArtBadge art={item.art} />
                        </div>
                        <div>
                          <Title className="text-labels-secondary text-xs font-semibold p-0.5">
                            {t(
                              'domain.mitarbeiter.feiertagskonto.kontoausgleich.tage',
                            )}
                          </Title>
                          <div>{item.tage.toLocaleString('de-DE')}</div>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <BemerkungDrawer bemerkung={item.bemerkung} />
                        <Button
                          variant="secondary-red"
                          iconOnly
                          size="small"
                          aria-label={t('actions.löschen')}>
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            ))}
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardContent className="p-4">
            <EmptyState
              title={t(
                'domain.mitarbeiter.feiertagskonto.kontoausgleich.noDataTitle',
              )}
              description={t(
                'domain.mitarbeiter.feiertagskonto.kontoausgleich.noDataDescription',
                { year: '2026' }, //TODO: context einbinden
              )}
              icon={
                <FontAwesomeIcon
                  icon={faCalendarCirclePlus}
                  className="text-neutrals-700"
                />
              }></EmptyState>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
